import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/equipment/_layout/overview')({});